import { translate } from '../../../../../common/i18n';

Blockly.Blocks.go_back_to_virtual = {
    init: function init() {
        this.appendDummyInput().appendField(translate('Go Back To Virtual Trades'));
        this.setColour('#f2f2f2');
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setTooltip(
            translate(
                'It will tell the system to use the connected virtual account in the next trade. If the virtual trades settings are disabled, it will be ignored'
            )
        );
    },
    onchange: function onchange() {},
};

Blockly.JavaScript.go_back_to_virtual = () => 'BinaryBotPrivateVirtualSettings.changeToVirtual = true;';



// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/virtualtrades/gobacktovirtual.js